//# sourceMappingURL=wss_connected.mjs.map
/// <reference types="./wss_connected.d.mts" />
import * as $json from "../../../gleam_json/gleam/json.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $user_id from "../../data/auth/user_id.mjs";
import { toList, CustomType as $CustomType } from "../../gleam.mjs";

export class WssConnected extends $CustomType {
  constructor(id, client_type, user_id, org_id, organization_name, user_name) {
    super();
    this.id = id;
    this.client_type = client_type;
    this.user_id = user_id;
    this.org_id = org_id;
    this.organization_name = organization_name;
    this.user_name = user_name;
  }
}
export const WssConnected$WssConnected = (id, client_type, user_id, org_id, organization_name, user_name) =>
  new WssConnected(id,
  client_type,
  user_id,
  org_id,
  organization_name,
  user_name);
export const WssConnected$isWssConnected = (value) =>
  value instanceof WssConnected;
export const WssConnected$WssConnected$id = (value) => value.id;
export const WssConnected$WssConnected$0 = (value) => value.id;
export const WssConnected$WssConnected$client_type = (value) =>
  value.client_type;
export const WssConnected$WssConnected$1 = (value) => value.client_type;
export const WssConnected$WssConnected$user_id = (value) => value.user_id;
export const WssConnected$WssConnected$2 = (value) => value.user_id;
export const WssConnected$WssConnected$org_id = (value) => value.org_id;
export const WssConnected$WssConnected$3 = (value) => value.org_id;
export const WssConnected$WssConnected$organization_name = (value) =>
  value.organization_name;
export const WssConnected$WssConnected$4 = (value) => value.organization_name;
export const WssConnected$WssConnected$user_name = (value) => value.user_name;
export const WssConnected$WssConnected$5 = (value) => value.user_name;

export function encode(w_s_s_connected) {
  let id = w_s_s_connected.id;
  let client_type = w_s_s_connected.client_type;
  let user_id = w_s_s_connected.user_id;
  let org_id = w_s_s_connected.org_id;
  let organization_name = w_s_s_connected.organization_name;
  let user_name = w_s_s_connected.user_name;
  return $json.object(
    toList([
      ["id", $json.string(id)],
      ["client_type", $json.string(client_type)],
      ["user_id", $user_id.encode(user_id)],
      ["org_id", $json.string(org_id)],
      ["organization_name", $json.string(organization_name)],
      ["user_name", $json.string(user_name)],
    ]),
  );
}

export function decoder() {
  return $decode.field(
    "id",
    $decode.string,
    (id) => {
      return $decode.field(
        "client_type",
        $decode.string,
        (client_type) => {
          return $decode.field(
            "user_id",
            $user_id.decoder(),
            (user_id) => {
              return $decode.field(
                "org_id",
                $decode.string,
                (org_id) => {
                  return $decode.field(
                    "organization_name",
                    $decode.string,
                    (organization_name) => {
                      return $decode.field(
                        "user_name",
                        $decode.string,
                        (user_name) => {
                          return $decode.success(
                            new WssConnected(
                              id,
                              client_type,
                              user_id,
                              org_id,
                              organization_name,
                              user_name,
                            ),
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}
